<template>
  <DashboardIndex activeViewName="signals" v-bind="$attrs"></DashboardIndex>
</template>

<script>
import DashboardIndex from "../../modules/dashboard/components/DashboardIndex.vue";
export default {
  name: "Signals",
  components: {
    DashboardIndex
  }
};
</script>

<style scoped>

</style>
